import React from 'react';
import { cn } from '@/lib/core/utils';

interface InfoRowProps {
  label: string;
  value: string | number | null | undefined;
  fallback?: string;
  valueClassName?: string;
  labelClassName?: string;
  className?: string;
}

export const InfoRow: React.FC<InfoRowProps> = ({ 
  label, 
  value, 
  fallback = 'N/A',
  valueClassName,
  labelClassName,
  className
}) => (
  <div className={cn("flex justify-between", className)}>
    <span className={cn("text-sm font-medium text-foreground", labelClassName)}>{label}:</span>
    <span className={cn("text-sm text-muted-foreground", valueClassName)}>
      {value ?? fallback}
    </span>
  </div>
);